/* unplugin-vue-components disabled */
export default {
  mixins: [ModelValue(String)],
  props: {
    placeholder: {type: String, default: 'Ask..'},
    editorDisabled: {type: Boolean, default: false},
    allowResize: {type: Boolean, default: true}
  },
  emits: ['push', 'rows'],
  data() {
    return {
      rows: 1
    }
  },
  watch: {
    async value() {
      this.rows = 1
      this.$emit('rows', this.rows)
      this.$nextTick(this.updateRows)
    },
    allowResize(val){
      if (val) {
        console.log('rows', this.rows)
      }
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    blur() {
      this.$refs.input.blur()
    },
    setCommand(command) {
      this.value = this.value === '' ? `${command} ` : `${this.value} ${command} `
      this.$nextTick(() => {
        this.updateRows()
        this.focus()
      })
    },
    updateRows() {
      const input = this.$refs.input
      if (input.clientHeight < input.scrollHeight && this.rows < 3) {
        if (!this.allowResize) {
          this.$emit('rows', this.rows + 1)
          return
        }
        this.rows += 1
        this.$emit('rows', this.rows)
        this.$nextTick(this.updateRows)
      }
    },
    onKeyEnter(ev) {
      if (ev.shiftKey) return
      ev.preventDefault()
      this.$emit('push', ev)
    }
  }
}
